(function () {
    'use strict';

    angular
        .module('invesfleet')
        .directive('recompile', recompile);

    recompile.$inject = ['$parse', '$compile'];

    function recompile($parse, $compile) {

        var directive = {
            transclude: true,
            controller: function ($scope, $transclude,
                $attrs, $element) {
                var childScope;

                $scope.$watch($attrs.recompileWatch, function (value) {
                    $element.empty();
                    if (childScope) {
                        childScope.$destroy();
                        childScope = null;
                    }

                    $transclude(function (clone, newScope) {
                        childScope = newScope;
                        $element.append(clone);
                    });
                });

                if ($attrs.recompileOn) { 
                    $scope.$on($attrs.recompileOn, function (e) {
                        $element.empty();
                        if (childScope) {
                            childScope.$destroy();
                            childScope = null;
                        }

                        $transclude(function (clone, newScope) {
                            childScope = newScope;
                            $element.append(clone);
                        });
                    });
                }
            }
        };

        return directive;
    }
})();